var _style, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon_svg__st7{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.7 362.1l2.2-3.1 104.5-198.3.2-2.1L155.5 72c-3.9-7.3-14.7-5.4-16 2.7L94.7 362.1z",
    fill: "#ffc24a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.2 224.1l34.3-35.1-34.3-65.5c-3.3-6.2-12.4-6.2-15.6 0l-18.3 35v3l33.9 62.6z",
    fill: "#f4bd62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6820c",
    d: "M94.7 362.1l1-1 3.6-1.5 133.8-133.2 1.6-4.6-33.3-63.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 429.3l121-67.5-34.6-212.9c-1.1-6.7-9.3-9.3-14-4.5L94.7 362.1l120.4 67.2c7.5 4.3 16.8 4.3 24.4 0",
    fill: "#fde068"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M359.5 361.2L325.2 150c-1.1-6.6-7.9-9.3-12.6-4.6L96 361.7l119 66.5c7.5 4.2 16.7 4.2 24.3 0l120.2-67z",
    fill: "#fcca3f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 427.3c-7.6 4.2-16.9 4.2-24.5 0L95.6 361.1l-1 1L215 429.3c7.6 4.2 16.9 4.2 24.5 0l121-67.5-.3-1.8-120.7 67.3z",
    fill: "#eeab37"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-80.805 326.662 347.578)",
    cx: 326.7,
    cy: 347.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#757575",
    r: 78.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "icon_svg__st7",
    d: "M291.1 326.2l35-17.7 36 17.7v18l-36-17.8-35 17.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "icon_svg__st7",
    d: "M291.1 356.9l35-17.8 36 17.8v17.9l-36-17.8-35 17.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "icon_svg__st7",
    d: "M326.2 374.4l10.2-4.8 18 8.3-28.2 13.5z"
  })));
}

export default SvgIcon;